module.exports = __webpack_public_path__ + "img/business-and-finance-2.4e2ae174.svg";